/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React, { ReactElement } from 'react';

import ChartWrapper from './ChartWrapper';
import {
  withTerminalHistoryChartHOCAndNoDataAvailableHOC,
  defaultChartOptions,
  getSeriesNameSuffix,
} from './WithTerminalHistoryChartHOC';
import { chartSeriesContent, ChartItemKeys, ChartType } from '../ChartSeriesItems';
import merge from 'lodash/merge';
import { getTooltipPointFormatterToFixedTwoDigits } from '../ChartDataFormatterUtils';
import { TerminalTypeLabel } from '../../../../../shared/entities/terminal';
import { isNil } from 'lodash';


interface AntennaPointingAnglesChartProps {
  index: number;
  text: string;
  id: string;
  chart: Highcharts.Chart | null;
  titlePrefixTerminalType?: TerminalTypeLabel;
  children: ReactElement | ReactElement[];
}
const AntennaPointingAnglesChart = (props: AntennaPointingAnglesChartProps) => {
  const { index, text, id, children, titlePrefixTerminalType } = props;
  let chartName = text;

  if (!isNil(titlePrefixTerminalType)) {
    chartName = `${getSeriesNameSuffix(titlePrefixTerminalType)}${chartName}`;
  }

  return (
    <ChartWrapper name={chartName} id={id} index={index} chartType={ChartItemKeys.antennaPointingAngles}>
      {children}
    </ChartWrapper>
  );
};

const getChartOptions = () => {
  const defaultOptions = { ...defaultChartOptions(ChartType.line) };
  return merge(defaultOptions, {
    yAxis: {
      labels: {
        format: '{value}°',
      },
      title: {
        text: 'degrees',
      },
    },
    plotOptions: { series: { custom: { useDetailedLabelSymbols: true } } },
    tooltip: {
      pointFormatter: getTooltipPointFormatterToFixedTwoDigits,
    },
  });
};

export default withTerminalHistoryChartHOCAndNoDataAvailableHOC(
  AntennaPointingAnglesChart,
  ChartType.line,
  getChartOptions(),
  chartSeriesContent[ChartItemKeys.antennaPointingAngles],
  'antennaPointAnglesGapSec',
);
